import { createFileRoute } from '@tanstack/react-router';
import { tiktokStaticData } from '../tiktok';
import { checkCountryIdBeforeLoad } from '../instagram';

export const Route = createFileRoute('/_private-routes/hashtag-analytics/tiktok/')({
  staticData: tiktokStaticData,
  beforeLoad: checkCountryIdBeforeLoad('/hashtag-analytics/tiktok/hashtag/$countryId')
});
